window.Tracking ?= {}

safeInit = (obj, payload, cb) ->
  try
    obj.init(payload, cb)
  catch err
    OptimizeSuite.TrackingHub.add "DealPage-FrontEndInit-Error",
      error: err
    if window.location.hostname == 'localhost' and console.error?
      console.error err
    cb()

Tracking.Initializer = (timeoutInMs = 30*1000) ->
  inFlight = 0
  @_hasRun = false
  finished = false

  run: (modules, payload, cb) ->
    for module in modules
      inFlight++
      safeInit module, payload, =>
        inFlight--
        if inFlight == 0 && @_hasRun && !finished
          finished = true
          cb()

    @_hasRun = true
    if inFlight == 0 && !finished
      finished = true
      cb()

    setTimeout (->
      unless finished
        OptimizeSuite.TrackingHub.add "DealPage-FrontEndInit-Timeout",
          numberInFlight: inFlight
        finished = true
        if window.location.hostname == 'localhost' and console.error?
          console.error "Frontend Module Initialization timed out"
        cb()
    ), timeoutInMs


module.exports = Tracking.Initializer



// WEBPACK FOOTER //
// ./modules/tracking/frontend/initializer.coffee